/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Ask_Values_DescInputs */

const en_ui_onboarding_ask_values_desc = /** @type {(inputs: Ui_Onboarding_Ask_Values_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender and heart rate, optional weight, birth year, FTP, pace and threshold HR`)
};

const de_ui_onboarding_ask_values_desc = /** @type {(inputs: Ui_Onboarding_Ask_Values_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht und Herzfrequenz, optional Gewicht, Geburtsjahr, FTP, Tempo und Schwellenpuls`)
};

/**
* | output |
* | --- |
* | "Gender and heart rate, optional weight, birth year, FTP, pace and threshold HR" |
*
* @param {Ui_Onboarding_Ask_Values_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_ask_values_desc = /** @type {((inputs?: Ui_Onboarding_Ask_Values_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Ask_Values_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_ask_values_desc(inputs)
	return de_ui_onboarding_ask_values_desc(inputs)
});